<template>
  <div class="flex-center flex-col">
    <div class="flex-center flex-col gap-4 w-full px-4 xs:max-w-[calc(100vw-2rem)]">
      <ProductModalGallery :product="product" />

      <h1 class="h1 text-center">
        {{ product.title }}
      </h1>
      <div
        v-if="descriptionHtml?.length"
        class="text-center"
        v-html="descriptionHtml"
      />
      <ProductAllerganWarning :tags="product.tags" />
      <a
        href="#reviews"
        @click.prevent="$theme.scrollIntoView('.junip-product-review')"
      >
        <DynamicStars
          v-if="mainProduct"
          :count="Number(mainProduct.ratingCount)"
          :rating="Number(mainProduct.ratingAverage)"
        />
      </a>
    </div>
    <div class="z-10 flex-center sticky -top-5 py-3 w-full xs:max-w-[calc(100vw-2rem)] bg-white">
      <BundleQuantityControl
        v-if="mainProduct"
        :product-id="mainProduct.id"
        :product-key="String(mainProduct.key)"
        :title="mainProduct.title"
        class="max-w-[160px]"
      />
    </div>
    <div
      class="relative flex-center flex-col gap-4 pb-5 pt-12 mt-10 border-t w-full xs:max-w-[calc(100vw-2rem)]"
      :style="{ 'background-color': bgColor?.value }"
    >
      <div class="border px-6 py-2 rounded-full text-2xl font-semibold bg-white absolute -top-6">
        What's Inside?
      </div>
      <div
        class="flex flex-wrap gap-2 justify-center px-8"
      >
        <div
          v-for="ingredient in ingredients"
          :key="ingredient"
          class="px-2 py-1 bg-white rounded-full text-xs font-semibold text-gray-800"
        >
          {{ ingredient }}
        </div>
      </div>
      <div class="p-3 rounded-2xl bg-white">
        <ResponsiveImage
          v-if="nutritionImage"
          class="w-64"
          :image="nutritionImage"
          :width="256"
          :alt="nutritionFacts"
          loading="lazy"
          tabindex="0"
        />
        <p class="mt-2 text-gray-800 text-xs text-left font-semibold uppercase leading-4">
          DOES NOT CONTAIN ERYTHRITOL.
        </p>
      </div>
    </div>
  </div>
  <div
    v-if="mainProduct"
    class="junip-product-review"
    :data-product-id="mainProduct.id"
  >
    <div class="flex items-center justify-center py-16">
      <Loader />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProductsStore } from '@/stores'
import ProductModalGallery from './product-modal-gallery.vue'
import ResponsiveImage from '../shared/v2/responsive-image.vue'
import BundleQuantityControl from './bundle-quantity-control.vue'
import ProductAllerganWarning from './product-allergan-warning.vue'
import Loader from '../shared/loader.vue'
import { DynamicStars } from '@oatsovernight/storybook'
import type { GraphqlBundleProduct } from '@/types/bundle'

export interface Props {
  product: GraphqlBundleProduct
}

const props = defineProps<Props>()
const nutritionFacts = props.product.nutrition?.value || props.product.title
const { nutritionImage, descriptionHtml, ingredients, bgColor } = props.product

/* Need to use mainProduct because cart is using id and key from mainProduct */
const products = useProductsStore()
const mainProduct = computed(() => products.productList.find(p => p.bpId === props.product.nid))
</script>
